import {
  TrusteesType,
  UpdateTrusteesType
} from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { Trustee, Trustees } from 'service/dto/trustee.dto';
import { errorHandler } from 'utils';

class TrusteeService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createTrustee = async (trusteesType: TrusteesType) => {
    try {
      const response = await this.baseService.post(
        '/trustee/create',
        trusteesType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  checkIfEmailInUse = async (email: string) => {
    const response = await this.baseService.get(
      `/trustee/email-exists/${email}`
    );
    return response.data;
  };

  updateTrustee = async (
    trusteeId: number,
    updateTrusteesType: UpdateTrusteesType
  ) => {
    try {
      const response = await this.baseService.put(
        `/trustee/${trusteeId}`,
        updateTrusteesType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getTrustee = async (trusteeId: number): Promise<Trustee> => {
    try {
      const response = await this.baseService.get(`/trustee/${trusteeId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getTrusteeDetails = async (trusteeId: number): Promise<Trustee> => {
    try {
      const response = await this.baseService.get(
        `/trustee/details/${trusteeId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getTrustees = async (search?: string | undefined): Promise<Trustees> => {
    try {
      const response = await this.baseService.get(`/trustee?search=${search}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteTrustee = async (trusteeId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(`/trustee/${trusteeId}`);
      return response.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default TrusteeService;
